import { Resource } from '../../_service/resource/resource';

export enum UserRoles {
    Anonymous, Authenticated, Vip, Enterprise, Couple, Editor, Admin
}

export interface UserInterface {
    id;
    name: string;
    accountName: string;
    nickname: string;
    gender: string;
    avatar: string;
    background: string;
    experience: number;
    expToNextLevel: number;
    level: number;
    dnCoins: number;
    membership: string;
    membershipExpiryDate: string;
    roleId: number;
    daysOfMembership: number;
    region: string;
    lastLogin: string;
    lastIP: string;
    loginTimes: number;
    permissions: Array<any>;
    registerDate: string;
    autoKey:string;
    privateFolder: {
        available: boolean;
        secret: string;
        securityMode: string;
    };
    token: {
        expire: string;
        gid: number;
        sign: string;
        token: string;
    };
    // notifications: {
    //     favorites: number;
    //     messages: number;
    // };
    officalUp: boolean;
    isOfficalSpeaker: boolean;
    autoSendServiceMsgUids: Array<any>;
    trendNum: number;
    albumNum: number;
    smallVideoNum: number;
    videoNum: number;
    userKey: string;
}

export class NotifyMessageCount
{
    favorites:number;
    messages:number;
    pm: number;
    // subscriptions:number;
    follows:number;
    constructor()
    {
        this.favorites = 0;
        this.messages = 0;
        this.pm = 0;
        // this.subscriptions = 0;
        this.follows = 0;
    }
}

export class User implements UserInterface {
    
    autoKey = "";
    id = null;
    name = '';
    accountName = '';
    nickname = '';
    gender = '';
    avatar = undefined;
    background = '';
    experience = 0;
    expToNextLevel = 0;
    level = 0;
    dnCoins = 0;
    membership = '';
    membershipExpiryDate = '';
    roleId = -1;
    daysOfMembership = 0;
    region = '';
    lastLogin = '';
    lastIP = '';
    loginTimes = 0;
    permissions: Array<any> = [];
    registerDate = '';
    key = '';
    privateFolder = {
        available: false,
        secret: '',
        securityMode: 'password',
    };
    token: {
        expire: '',
        gid: null,
        sign: '',
        token: '',
    };
    // notifications: {
    //     favorites: number;
    //     messages: number;
    // };
    officalUp: boolean;
    isOfficalSpeaker: boolean;
    colorGuideDone: number;
    signature: string;
    isBindTel: boolean;
    autoSendServiceMsgUids = [];
    trendCount: number;
    lastTrend = {};
    trendNum = 0;
    albumNum = 0;
    smallVideoNum = 0;
    videoNum = 0;
    userKey = '';

    constructor(private _isCurrentUser: Boolean ) { }

    get avatarPath() {
        if (this.avatar) {
            return this.avatar;
        }

        if (this.avatar === undefined) {
            return;
        }

        switch (this.gender) {
            case 'male': {
                return Resource.maleDefaultAvatar;
            }
            case 'female': {
                return Resource.femaleDefaultAvatar;
            }
            default: {
                return Resource.defaultAvatar;
            }
        }
    }

    get backgroundPath() {
        if (this.background) {
            return this.background;
        }
        return Resource.defaultBackground;
    }

    get badge() {
        switch (this.membership) {
            case 'cpvip': {
                return Resource.cpVipBadge;
            }
            case 'editor': {
                return Resource.editorBadge;
            }
            case 'etvip': {
                return Resource.etVipBadge;
            }
            case 'gvip': {
                return Resource.gVipBadge;
            }
            case 'vip': {
                return Resource.vipBadge;
            }
            case 'royalAdmin': {
                return Resource.royalAdminBadge;
            }
            case 'royalVip': {
                return Resource.royalVipBadge;
            }
            default: {
                return Resource.vipBadge;
            }
        }
    }

    get mBadge() {
        switch (this.membership) {
            case 'cpvip': {
                return Resource.mCpVipBadge;
            }
            case 'editor': {
                return Resource.mEditorBadge;
            }
            case 'etvip': {
                return Resource.mEtVipBadge;
            }
            case 'gvip': {
                return Resource.mGVipBadge;
            }
            case 'vip': {
                return Resource.mVipBadge;
            }
            case 'royalAdmin': {
                return Resource.mRoyalAdminBadge;
            }
            case 'royalVip': {
                return Resource.mRoyalVipBadge;
            }
            default: {
                return '';
            }
        }
    }
    get groupName() {
        switch (this.membership) {
            case 'cpvip': {
                return "情侣VIP";
            }
            case 'editor': {
                return "情侣VIP";
            }
            case 'etvip': {
                return "企业会员";
            }
            case 'gvip': {
                return "黄金VIP";
            }
            case 'vip': {
                return "普通会员";
            }
            case 'royalAdmin': {
                return "超级管理员";
            }
            case 'royalVip': {
                return "至尊VIP";
            }
            default: {
                return '';
            }
        }
    }

    get from() {

        if (!this.region) {
            return '';
        }

        if (this._isCurrentUser) {
            // return '来自' + this.region;
            return this.region;
        }

        switch (this.gender) {
            case 'male': {
                return '他来自' + this.region;
            }
            case 'female': {
                return '她来自' + this.region;
            }
            default: {
                return '来自' + this.region;
            }
        }
    }

    get rechargeWords() {
        switch (true) {
            case (this.daysOfMembership === 0): {
                return '升级VIP';
            }
            case (this.daysOfMembership < 0): {
                return '升级VIP';
            }
            case (this.daysOfMembership < 30): {
                return 'VIP续费';
            }
            case (this.daysOfMembership >= 30): {
                return 'VIP续费';
            }
        }
    }

    get daysLeftOfMembership() {
        switch (true) {
            case (this.daysOfMembership > 0): {
                return 'VIP 剩余 <span class=\'text-white\'>' + this.daysOfMembership + '</span> 天' ;
            }

            case (this.daysOfMembership < 0): {
                return 'VIP 会员已过期' ;
            }

            default: {
                return '还不是 VIP 会员' ;
            }
        }
    }

    get userStars() {
        /** TODO:  需要月亮、太阳的图标 */
        let res = '';

        // const sun = Math.floor(this.level / 10);
        // const remain = this.level % 10;
        // const moon =  Math.floor(remain / 5);
        // const star = remain % 5;

        // for (let i = 0; i < sun; i++) {
        //     res += '<span class="user-star sun"></span>';
        // }
        // for (let i = 0; i < moon; i++) {
        //     res += '<span class="user-star moon"></span>';
        // }
        // for (let i = 0; i < star; i++) {
        //     res += '<span class="user-star star"></span>';
        // }
        //console.log(res);
        if(this.level > 5)
        {
           for (let i = 0; i < this.level - 5; i++) {
            res += '<span class="user-star moon"></span>';
            }
        }
        else
        {
            for (let i = 0; i < this.level - 5; i++) {
                res += '<span class="user-star star"></span>';
                }
        }

        return res;
    }
}
